import {Link, useLocation} from "react-router-dom";
import {
    indexUrl,
    contactUsUrl
} from "../../Route_urls";
import {LazyLoadImage} from 'react-lazy-load-image-component';

import useWindowDimensions from "../hooks/WindowDimension/useWindowDimensions";
import React, {useState, useEffect, useRef} from "react";
import {investitum_logo} from "../../static/icons/icons";

const Navigation = () => {
    const {isMobile} = useWindowDimensions();
    const {pathname} = useLocation();
    const [nav, setNav] = useState(false);
    const wrapperRef = useRef(null);

    const handleNav = () => {
        setNav((prev) => !prev);
    };

    useEffect(() => {
        if (!isMobile) {
            setNav(false);
        }
    }, [isMobile]);

    useClickOutside(wrapperRef, () => {
        setNav(false);
    });

    function useClickOutside(ref, onClickOutside) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    onClickOutside();
                }
            }

            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref, onClickOutside]);
    }
    const navItems = [
        {id: 1, text: "Home", href: indexUrl},
        {id: 2, text: "Contact", href: contactUsUrl},
    ];

    const navLinkClass = (href) => `rounded-full px-4 py-2 text-sm font-semibold tracking-wide transition ${pathname === href ? "bg-[#b65c2d] text-white shadow-[0_12px_30px_rgba(182,92,45,0.25)]" : "text-[#5a4d40] hover:bg-white/70 hover:text-[#1f1a14]"}`;

    return (
        <header className="sticky top-0 z-50 px-3 pt-3 md:px-5" ref={wrapperRef}>
            <div className="mx-auto max-w-screen-xl rounded-[28px] border border-[#c6b49a]/60 bg-[#f8f1e5]/85 shadow-[0_20px_50px_rgba(83,58,26,0.10)] backdrop-blur-xl">
                <div className="flex items-center justify-between px-4 py-3 md:px-6 xl:px-8">
                    <Link to={indexUrl} className="flex shrink-0 items-center">
                        <div className="flex w-44 flex-row items-center md:w-48">
                            <LazyLoadImage
                                alt={"Investitum Logo"}
                                height={'120'}
                                src={investitum_logo}
                                width={'200'}
                            />
                        </div>
                    </Link>

                    <nav className="hidden items-center gap-2 xl:flex">
                        {navItems.map((item) => (
                            <Link
                                key={item.id}
                                className={navLinkClass(item.href)}
                                to={item.href}
                            >
                                {item.text}
                            </Link>
                        ))}
                    </nav>

                    <button
                        type="button"
                        onClick={handleNav}
                        className="rounded-full border border-[#ccb79a] bg-white/70 p-2 text-[#5a4d40] transition hover:bg-white md:hidden"
                        aria-label={nav ? "Close menu" : "Open menu"}
                        aria-expanded={nav}
                    >
                        {nav ? (
                            <svg className="h-6 w-6 stroke-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 3L17 17M3 17L17 3" strokeWidth="2"/>
                            </svg>
                        ) : (
                            <svg className="h-5 w-5 stroke-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" strokeWidth="1"/>
                            </svg>
                        )}
                    </button>
                </div>

                <div className="border-t border-[#d8c8b0]/70 px-4 pb-3 pt-2 xl:hidden">
                    <div className="flex items-center gap-2 overflow-x-auto pb-1">
                        {navItems.map((item) => (
                            <Link
                                key={item.id}
                                className={`${navLinkClass(item.href)} whitespace-nowrap`}
                                to={item.href}
                            >
                                {item.text}
                            </Link>
                        ))}
                    </div>
                </div>
            </div>

            <div
                className={`fixed inset-0 z-40 bg-[rgba(31,26,20,0.16)] backdrop-blur-sm transition ${nav ? "opacity-100" : "pointer-events-none opacity-0"}`}
                onClick={handleNav}
            />

            <aside
                className={`fixed left-0 top-0 z-50 flex h-full w-[82%] max-w-sm flex-col border-r border-[#c6b49a] bg-[#f7efe3] px-6 py-6 shadow-[0_28px_60px_rgba(83,58,26,0.18)] transition-transform duration-300 md:hidden ${nav ? "translate-x-0" : "-translate-x-full"}`}
            >
                <div className="flex items-center justify-between">
                    <div className="w-36">
                        <LazyLoadImage
                            alt={"Investitum Logo"}
                            height={'120'}
                            src={investitum_logo}
                            width={'200'}
                        />
                    </div>
                    <button
                        type="button"
                        onClick={handleNav}
                        className="rounded-full border border-[#ccb79a] bg-white/80 p-2 text-[#5a4d40]"
                        aria-label="Close menu"
                    >
                        <svg className="h-5 w-5 stroke-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 3L17 17M3 17L17 3" strokeWidth="2"/>
                        </svg>
                    </button>
                </div>

                <div className="mt-8 flex flex-col gap-3">
                    {navItems.map((item) => (
                        <Link
                            key={item.id}
                            to={item.href}
                            onClick={handleNav}
                            className={`rounded-2xl px-4 py-3 text-base font-semibold transition ${pathname === item.href ? "bg-[#b65c2d] text-white" : "bg-white/70 text-[#3f3428] hover:bg-white"}`}
                        >
                            {item.text}
                        </Link>
                    ))}
                </div>

                <div className="mt-auto rounded-[24px] border border-[#d7c6ae] bg-white/70 p-4">
                   
                    <p className=" text-sm text-[#7a6d5f]">
                        Sweden | Croatia | World
                    </p>
                </div>
            </aside>
        </header>
    );
};

export default Navigation;
